import { IPhuketBeach, ISamuiBeach } from "@/lib/types/beach";
import { IComplexPage } from "@/lib/types/complexPage";
import {
  SvgBeach,
  SvgGym,
  SvgHill,
  SvgOwning,
  SvgParking,
  SvgPublicGarden,
  SvgReception,
  SvgSecurity,
  SvgShuttle,
  SvgStories,
  SvgSwimming,
  SvgVideoSurveillance,
  SvgView,
  SvgRestaurant,
  SvgGolf,
  SvgTennis,
  SvgManagement,
  SvgKidsRooms,
  SvgCoworking,
  SvgJacuzzi,
  SvgSPA,
  SvgCity,
  SvgPlain,
  SvgCoast,
  SvgRestroom,
  SvgArea,
  SvgVillaArea,
  SvgPrivatePool,
  SvgPrivateGarden,
  SvgTerrace,
  SvgBalcony,
  SvgStaffRoom,
} from "@/lib/ui/icons/complex-info";
import { SvgBedrooms } from "@/lib/ui/icons/complex-info/SvgBedrooms";
import { ReactNode } from "react";

interface PrefilledCardBase {
  title?: number | string | string[] | IPhuketBeach | ISamuiBeach | "";
  description?: string;
  isAlwaysPresent?: boolean;
  value?: number ;
  id: string;
  additionalBeach?: {
    title: IPhuketBeach | ISamuiBeach | "";
    value: number;
  }
};

interface PrefilledCard extends PrefilledCardBase{
  icon: ReactNode;
}

export const infoCards = {
  pool: {
    title: "swimming",
    id: "swimming",
    icon: <SvgSwimming />,
  },
  gym: {
    title: "gym",
    id: "gym",
    icon: <SvgGym />,
  },
  parking: {
    title: "parking",
    id: "parking",
    icon: <SvgParking />,
  },
  security: {
    title: "security",
    id: "security",
    icon: <SvgSecurity />,
  },
  cctv: {
    title: "cctv",
    id: "cctv",
    icon: <SvgVideoSurveillance />,
  },
  publicGarden: {
    icon: <SvgPublicGarden />,
    title: "garden",
    id: "garden",
  },

  shuttle: {
    icon: <SvgShuttle />,
    title: "shuttle",
    id: "shuttle",
  },
  tennis: {
    icon: <SvgTennis />,
    title: "tennis",
    id: "tennis",
  },
  reception: {
    icon: <SvgReception />,
    title: "reception",
    id: "reception",
  },
  restaurant: {
    icon: <SvgRestaurant />,
    title: "restaurant",
    id: "restaurant",
  },
  golf: {
    icon: <SvgGolf />,
    title: "golf",
    id: "golf",
  },
  management: {
    title: "management",
    icon: <SvgManagement />,
    id: "management",
  },
  kidsRoom: {
    title: "kidsRoom",
    icon: <SvgKidsRooms />,
    id: "kidsRoom",
  },
  coworking: {
    icon: <SvgCoworking />,
    title: "coworking",
    id: "coworking",
  },
  jacuzzi: {
    icon: <SvgJacuzzi />,
    title: "jacuzzi",
    id: "jacuzzi",
  },
  spa: {
    icon: <SvgSPA />,
    title: "spa",
    id: "spa",
  },
  privatePool: {
    icon: <SvgPrivatePool />,
    title: "privatePool",
    id: "privatePool",
  },
  privateGarden: {
    icon: <SvgPrivateGarden />,
    title: "privateGarden",
    id: "privateGarden",
  },
  terrace: {
    icon: <SvgTerrace />,
    title: "terrace",
    id: "terrace",
  },
  balcony: {
    icon: <SvgBalcony />,
    title: "balcony",
    id: "balcony",
  },
  staffRoom: {
    title: 'staffRoom',
    id: 'staffRoom',
    icon: <SvgStaffRoom />
  }
} as Record<(typeof properties)[number], { title: string; icon?: ReactNode }>;

const properties = [
  "landscape",
  "ownershipType",
  "stories",
  "views",
  "beach",
  "pool",
  "gym",
  "parking",
  "security",
  "cctv",
  "publicGarden",
  "management",
  "kidsRoom",
  "coworking",
  "jacuzzi",
  "shuttle",
  "tennis",
  "reception",
  "restaurant",
  "golf",
  "spa",
  "staffRoom"
];

const landscapeIcons = {
  COAST: <SvgCoast />,
  HILL: <SvgHill />,
  PLAIN: <SvgPlain />,
  CITY: <SvgCity />,
};

const prefilledCards: PrefilledCardBase[] = [
  {
    isAlwaysPresent: true,
    description: "landscape",
    id: "landscape",
  },
  {
    description: "ownershipType",
    id: "ownershipType",
    isAlwaysPresent: true,
  },
  {
    description: "stories",
    id: "stories",
    isAlwaysPresent: true,
  },
  {
    description: "views",
    id: "views",
    isAlwaysPresent: true,
  },
  {
    description: "beach",
    id: "beach",
    isAlwaysPresent: true,
  },
];
const complexIcons: Record<string, ReactNode> = {
"landscape": <SvgHill />,
"ownershipType": <SvgOwning />,
"stories": <SvgStories />,
"views": <SvgView />,
"beach": <SvgBeach />,
}
const singleVillaPrefilledCards: PrefilledCardBase[] = [
  {
    isAlwaysPresent: true,
    description: "bedrooms",
    id: "bedrooms",
  },
  {
    description: "bathrooms",
    id: "bathrooms",
    isAlwaysPresent: true,
  },
  {
    description: "area",
    id: "area",
    isAlwaysPresent: true,
  },
  {
    description: "villaArea",
    id: "villaArea",
    isAlwaysPresent: true,
  },
  {
    description: "stories",
    id: "stories",
    isAlwaysPresent: true,
  },
  {
    description: "beach",
    id: "beach",
    isAlwaysPresent: true,
  },
  {
    description: "ownershipType",
    id: "ownershipType",
    isAlwaysPresent: true,
  },
  {
    description: "views",
    id: "views",
    isAlwaysPresent: true,
  },
  {
    isAlwaysPresent: true,
    description: "landscape",
    id: "landscape",
  },
];
const singleVillaIcons: Record<string, ReactNode> = 
  {
    "bedrooms": <SvgBedrooms />,
    "bathrooms": <SvgRestroom />,
    "area": <SvgArea />,
    "villaArea": <SvgVillaArea />,
    "stories": <SvgStories />,
    "beach": <SvgBeach />,
    "ownershipType": <SvgOwning />,
    "views": <SvgView />,
    "landscape": <SvgHill />,
  };

export const getInfoCards = <M extends IComplexPage["saleObject"]>(
  salesObject: M,
  isSingleVilla?: boolean,
): {
  title?: string | number | string[];
  description?: string;
  icon: ReactNode;
  id: string;
}[] => {
  if (isSingleVilla) {
    const layout = salesObject.layouts[0];
    const result = JSON.parse(JSON.stringify(singleVillaPrefilledCards)) as PrefilledCard[];
    const salesEntries = Object.entries({
      ...{
        privatePool: layout?.privatePool,
        terrace: layout?.terrace,
        balcony: layout?.balcony,
        jacuzzi: layout?.jacuzzi,
        privateGarden: layout?.privateGarden,
      },
      ...salesObject.features,
    });
    
    const beach = salesObject.beaches[0];
    const additionalBeach = salesObject.beaches?.[1];

    result[0].title = `${layout?.bedrooms}`;
    result[1].title = `${layout?.bathrooms}`;
    result[2].title = `${layout?.area}`;
    result[3].title = `${layout?.landArea}`;
    result[4].title = `${layout?.floors}`;
    
    result[5].title = beach ? beach.beachId + ' ' : "";
    result[5].value = beach ? beach.distance : 0;
    
    if (additionalBeach) {
      result[5].additionalBeach = {
        title: additionalBeach.beachId || "",
        value: additionalBeach.distance || 0,
      };
    }

    result[6].title = salesObject.ownershipType;
    if (salesObject.features.landscape) {
      result[8].title = salesObject.features.landscape.toLowerCase();
      result[8].icon = landscapeIcons[salesObject.features.landscape];
    }
    for (let entry of salesEntries) {
      if (entry[0] === "views") {
        result[7].title = entry[1] as string[];
        if (result[7].title.includes('OTHER')) {
          result[7].title.splice(result[3].title.indexOf('OTHER'), 1);
          result[7].title.push('OTHER');
        }
      }
      if (entry[1] === true && properties.includes(entry[0])) {
        result.push({
          title: entry[0],
          icon: infoCards[entry[0]]?.icon as ReactNode,
          id: entry[0],
        });
      }
    }
    result.forEach((item) => {
      if (!item.icon){
        item.icon = singleVillaIcons[item.id]
      }
    })
    return result;
  } else {
    const salesEntries = Object.entries(salesObject.features);
    const beach = salesObject.beaches[0];
    const additionalBeach = salesObject.beaches?.[1];
    const result = JSON.parse(JSON.stringify(prefilledCards)) as PrefilledCard[];
    if (salesObject.features.landscape) {
      result[0].title = salesObject.features.landscape.toLowerCase();
      result[0].icon = landscapeIcons[salesObject.features.landscape];
    }

    result[1].title = salesObject.ownershipType;
    result[2].title =
      salesObject.storeysNumberFrom === salesObject.storeysNumberTo
        ? salesObject.storeysNumberFrom
        : `${salesObject.storeysNumberFrom}-${salesObject.storeysNumberTo}`;

    result[4].title = beach ? beach.beachId + ' ' : "";
    result[4].value = beach ? beach.distance : 0;

    if (additionalBeach) {
      result[4].additionalBeach = {
        title: additionalBeach.beachId || "",
        value: additionalBeach.distance || 0,
      };
    }

    for (let entry of salesEntries) {
      if (entry[0] === "views") {
        result[3].title = entry[1] as string[];
        if (result[3].title.includes('OTHER')) {
          result[3].title.splice(result[3].title.indexOf('OTHER'), 1);
          result[3].title.push('OTHER');
        }
      }
      if (entry[1] === true && properties.includes(entry[0])) {
        result.push({
          title: entry[0],
          icon: infoCards[entry[0]]?.icon as ReactNode,
          id: entry[0],
        });
      }
    }
    result.forEach((item) => {
      if (!item.icon){
        item.icon = complexIcons[item.id]
      }
    })
    return result;
  }
};
